const dataURItoBlob = (dataURI: string) => {
  const byteString = atob(dataURI.split(',')[1] as string);
  const mimeString = (
    (dataURI.split(',')[0] as string).split(':')[1] as string
  ).split(';')[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: mimeString });
};

export default dataURItoBlob;
